<script>

import { store } from './store.js'
import Fuse from 'fuse.js';

let options = {
    includeScore: true,
    threshold: 0.2,
    includeMatches: true,
    distance: 100,
    keys: ['make', 'range', 'model', 'year', 'condition']
  };


// Vue Search
export default {

  name: "VueWooSearch",

  data() {
    return {
        store,
        searchQuery : '',
        searchIsLoading: true,
        allAttributes: [],
        searchResults: [],
        filteredSearchResults: [],
        shopURL: wp_field_vars.wc_shop_url,
        fuse: new Fuse([], options)
      }
    },

    methods: {

      fetchData: function () {
        fetch(`/wp-json/goeuro/v1/products`)
        .then(response => response.json())
        .then(response => {

          this.searchIsLoading = false;
          const data = response;

          data.map((item) => {
            this.searchResults.push(item)
          })

          this.fuse.setCollection(this.searchResults);
        })

      },

      filterSearchResults: function(e){
        searchQuery = e.target.value;
        let filterQuery = this.fuse.search(searchQuery);
        this.filteredSearchResults = filterQuery;
      },


      clearSearchQuery: function (id){
        this.searchQuery = null;
        this.filteredSearchResults = [];
      },

    },

  mounted(){
    this.fetchData()
  },

}

</script>

  <template>
    <div>
      <div class="searchDropdown-wrapper search-wrapper">

        <form id="searchform" :action="shopURL" method="get">
          <input type="search" name="s" placeholder="Search" v-model="this.searchQuery" @keydown.esc="clearSearchQuery" @keyup="filterSearchResults" :disabled="this.searchIsLoading" autocomplete="off"/>
          <input type="hidden" name="post_type" value="product" />
        </form>

        <button v-if="this.searchQuery" @click.prevent="clearSearchQuery" class="searchInput-icon clear unstyled-button"></button>
      </div>

      <div v-if="this.searchIsLoading" class="vue-search-loading-wrapper">
        <slot></slot>
      </div>

      <div class="searchDropdown vertical-scroll" v-if="filteredSearchResults.length > 0">
        <ul class="searchDropdown-list">
          <li class="searchDropdown-list-item" v-for="(post, index) in filteredSearchResults" :key="post.item.id">

          <a class="searchDropdown-list-item-link" :href="post.item.permalink">

            <div v-if="post.item.image" class="searchDropdown-list-item-image-wrapper">
              <img loading="lazy" class="searchDropdown-list-item-image" :src="post.item.image" width="170" :alt="post.item.name"/>
            </div>

            <div class="searchDropdown-list-item-content">

                <div class="searchDropdown-list-item-content-inner">

                  <div class="searchDropdown-list-item-subheading">

                    <!-- CONDITION -->
                    <p class="searchDropdown-list-item-subheading-attr condition" v-if="post.item.condition.name">
                      {{post.item.condition.name + ' '}}
                    </p>

                    <!-- BRANDS AND RANGE -->
                    <p class="searchDropdown-list-item-subheading-attr" v-if="post.item.make">{{post.item.make + ' '}}</p>

                  </div>

                  <h3 class="searchDropdown-list-item-heading">
                    <span v-if="post.item.brand">{{post.item.brand + ' '}}</span>
                    <span v-if="post.item.range">{{post.item.range + ' '}}</span>
                    <span v-if="post.item.model">{{post.item.model + ' '}}</span>
                    <span v-if="post.item.year">{{post.item.year + ' '}}</span>
                    </h3>

                  <div class="price-wrapper">
                    <p class="price" aria-hidden="true">

                      <!-- Sale price -->

                      <span class="sale-price" v-if="post.item.sale_price && post.item.regular_price">
                        <s>Was £{{new Intl.NumberFormat('en-GB').format(post.item.regular_price)}}</s>
                        <strong>
                          £{{new Intl.NumberFormat('en-GB').format(post.item.sale_price)}}
                          <abbr v-if="post.item.condition.name == 'New'" title="On The Road price"> OTR</abbr>
                        </strong>
                      </span>

                      <!-- Regular price -->

                      <span class="regular-price" v-if="!post.item.sale_price && post.item.regular_price > 0">
                        <strong>
                          £{{new Intl.NumberFormat('en-GB').format(post.item.price)}}
                          <abbr v-if="post.item.condition.name == 'New'" title="On The Road price"> OTR</abbr>
                        </strong>
                      </span>

                      </p>

                      <p v-if="post.item.sale_price && post.item.regular_price" class="visually-hidden">Was £{{new Intl.NumberFormat('en-GB').format(post.item.regular_price)}}, now £{{new Intl.NumberFormat('en-GB').format(post.item.sale_price)}} (On The Road price)</p>

                  </div>

                  <div v-if="post.item.price_per_month" class="finance-wrapper">
                    <strong class="finance-price">£{{new Intl.NumberFormat('en-GB').format(post.item.price_per_month)}}<abbr v-if="post.item.condition.name == 'Used'" title="Hire Purchase (per month)"> /month HP</abbr></strong>
                    <p class="visually-hidden">£{{new Intl.NumberFormat('en-GB').format(post.item.price_per_month)}} a month on hire purchase</p>
                  </div>

                </div>
              </div>
              </a>
            </li>
          </ul>
        </div>

    </div>
</template>
